export default function Hero() {
  return (
    <section id="top" style={{ backgroundColor: '#781725' }} className="relative w-full min-h-[100dvh] md:h-[820px] md:min-h-0 overflow-hidden pt-20 md:pt-0">
      <div className="absolute inset-0 bg-gradient-to-br from-transparent to-black/60"></div>

      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-5 md:px-10 flex flex-col justify-center pb-8 md:pb-0">
        <div className="max-w-3xl animate-fade-up pt-10">
          <h1 className="font-heading text-background-50 text-[2.5rem] md:text-7xl leading-[1.15] font-bold">
            사건사고 다 <br />
            <span className="text-primary-400">당신의 마음까지 다</span>
          </h1>

          <p className="mt-4 md:mt-8 text-background-100 text-sm md:text-lg leading-relaxed max-w-2xl">
            다다손해사정은 고객의 신뢰를 바탕으로 고객과 함께 성장하는 것을 목표로 합니다.
            개인보험, 근재보험, 교통사고, 손해배상, 화재, 누수 등 다양한 분야에서
            정확하고 효과적인 손해사정 서비스를 제공합니다.
          </p>

          <div className="mt-6 md:mt-10 flex flex-col sm:flex-row gap-3 md:gap-4">
            <a
              href="tel:010-2696-9689"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-6 md:px-8 py-3.5 md:py-4 rounded-full text-sm tracking-wide flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap transition"
            >
              상담 신청하기
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:010-2696-9689"
              className="bg-background-50/10 hover:bg-background-50/20 border border-background-50/40 text-background-50 font-semibold px-6 md:px-8 py-3.5 md:py-4 rounded-full text-sm tracking-wide flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap backdrop-blur"
            >
              <i className="ri-phone-fill text-primary-300"></i>
              010-2696-9689
            </a>
          </div>
        </div>

        <div className="mt-8 md:mt-16 grid grid-cols-2 gap-3 md:gap-6 max-w-xl">
          {[
            { num: "1,382+", label: "누적 상담 건수" },
            { num: "82%", label: "의뢰인 만족도" },
          ].map((s) => (
            <div key={s.label} className="border-l border-background-50/30 pl-3 md:pl-4">
              <div className="text-primary-300 font-heading text-xl md:text-4xl font-bold">
                {s.num}
              </div>
              <div className="text-background-100 text-[10px] md:text-sm mt-0.5 md:mt-1 tracking-wide">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex-col items-center gap-2 text-background-50/80">
        <span className="text-[10px] tracking-[0.3em]">SCROLL</span>
        <i className="ri-arrow-down-line animate-bounce"></i>
      </div>
    </section>
  );
}